(function (window, document) {
  'use strict';

  function GridListToggle() {
    this.postsContainer = null;
    this.btnSquare = null;
    this.btnBars = null;
    this.handleClickSquare = this.handleClickSquare.bind(this);
    this.handleClickBars = this.handleClickBars.bind(this);
  }

  GridListToggle.prototype.init = function () {
    this.postsContainer = document.querySelector('.posts-container');
    if (!this.postsContainer) return;

    this.btnSquare = document.querySelector('.main__navigation__icon-button.square');
    this.btnBars = document.querySelector('.main__navigation__icon-button.bars');

    if (this.btnSquare) this.btnSquare.addEventListener('click', this.handleClickSquare);
    if (this.btnBars) this.btnBars.addEventListener('click', this.handleClickBars);
  };

  GridListToggle.prototype.handleClickSquare = function (e) {
    e.preventDefault();
    document.body.classList.remove('posts-container-list');
  };

  GridListToggle.prototype.handleClickBars = function (e) {
    e.preventDefault();
    document.body.classList.add('posts-container-list');
  };

  function bootGridListToggle() {
    var ctl = new GridListToggle();
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        ctl.init();
      });
      return;
    }

    ctl.init();
  }

  // Expor para debug sem poluir o escopo global demais
  window.AderbalGridListToggle = {
    boot: bootGridListToggle,
  };

  bootGridListToggle();
})(window, document);
